export default {
  maps: {
    confirm: "Confirmer",
    updateConfirmation: "Êtes-vous sûr de vouloir modifier les coordonnées dans la base de données ?",
    deleteConfirmation: "Êtes-vous sûr de vouloir supprimer ce compteur ?",
    backToOldPosition: "Revenir à l'ancienne position",
    addMeter: "Ajouter un compteur",
    savePosition: "Sauvegarder la position",
    deleteMeter: "Supprimer le compteur",
    export: "Exporter",
  },
};
